module.exports = __webpack_public_path__ + "img/vn5-telling-the-energy-story.b0ec7354.jpg";